import { Component, ViewChild, ElementRef } from "@angular/core";
import {
  IonicPage,
  Platform,
  ViewController,
  ActionSheetController,
  LoadingController,
  ToastController
} from "ionic-angular";
import { Camera } from "@ionic-native/camera";
import { MockupProvider } from "../../providers/mockup/mockup.provider";
import { TranslateService } from "@ngx-translate/core";
import { UserProvider } from "../../providers/user/user.provider";
import { UserModel } from "../../providers/user/user.model";

/**
 * Generated class for the AccountUpdatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-account-update",
  templateUrl: "account-update.html"
})
export class AccountUpdatePage {
  user_data: UserModel = new UserModel();
  i18n: string[] = [];
  @ViewChild("file") fileInput: ElementRef;
  fileToUpload: File = null;
  loading: any = null;
  edited: boolean = false;

  tags = ['Ionic', 'Angular', 'TypeScript'];

  constructor(
    private viewCtrl: ViewController,
    private camera: Camera,
    private platform: Platform,
    private translate: TranslateService,
    private actionSheetCtrl: ActionSheetController,
    private toastCtrl: ToastController,
    private mockupProvider: MockupProvider,
    private loadingCtrl: LoadingController,
    private userProvider: UserProvider
  ) {}

  ionViewDidEnter() {
    this.refresh();
  }

  onChange(val:string){
    console.log("val",val);
  }

  async refresh() {
    this.refreshLang();
    this.user_data = await this.userProvider.getUser();
    console.log("this.user", this.user_data);
  }

  refreshLang() {
    // console.log("refresh lang");
    this.translate
      .get([
        "PICTURE_ADDED_TO_GALLERY",
        "PICTURE_DOWNLOADED",
        "ERROR_SAVING_GALLERY",
        "EXPORT_IN_PROGRESS",
        "TITLE_ALERT_LEAVE",
        "MESSAGE_ALERT_LEAVE",
        "SAVE",
        "LEAVE_WITHOUT_SAVE",
        "SELECT_PICTURE",
        "OK",
        "YES",
        "NO",
        "CANCEL",
        "TITLE",
        "SUBTITLE",
        "DEMO_PICTURE",
        "LOAD_FROM_LIBRARY",
        "LOAD_FROM_COMPUTER",
        "USE_CAMERA"
      ])
      .subscribe(value => {
        this.i18n = value;
        // console.log("this.i18n",this.i18n);
      });
  }

  cancel() {
    this.viewCtrl.dismiss(null);
  }

  async save() {
    if(this.edited){
      await this.userProvider.updateUserPicture(this.user_data.uid, this.user_data.image);
      this.user_data.image ='users/' + this.user_data.uid;
    }
    await this.userProvider.updateUser(this.user_data);
    this.viewCtrl.dismiss(null);
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad AccountUpdatePage");
  }

  presentActionSheet() {
    let button_library = {
      text: this.i18n["LOAD_FROM_LIBRARY"],
      handler: () => {
        this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
      }
    };
    let button_camera = {
      text: this.i18n["USE_CAMERA"],
      handler: () => {
        this.takePicture(this.camera.PictureSourceType.CAMERA);
      }
    };
    let button_import_web = {
      text: this.i18n["LOAD_FROM_COMPUTER"],
      handler: () => {
        this.triggerFileInputClick();
      }
    };
    let button_cancel = {
      text: this.i18n["CANCEL"],
      role: "cancel"
    };
    let button_demo = {
      text: this.i18n["DEMO_PICTURE"],
      handler: () => {
        this.takeDemoPicture();
      }
    };
    let buttons = [button_demo, button_import_web, button_cancel];
    if (this.platform.is("cordova"))
      buttons = [button_demo, button_library, button_camera, button_cancel];

    let titletext = this.i18n["SELECT_PICTURE"];
    // console.log("titletext",titletext);
    let actionSheet = this.actionSheetCtrl.create({
      title: titletext,
      buttons: buttons
    });
    actionSheet.present();
  }

  triggerFileInputClick() {
    this.fileInput.nativeElement.click();
  }

  takeDemoPicture() {
    this.mockupProvider
      .getImageDemo()
      .then(dataUrl => {
        // console.log("takeDemoPicture success");
        return this.getPicture(dataUrl);
      })
      .then(picture => {
        this.edited = true;
      })
      .catch(err => {
        console.error("error loading takeDemoPicture", err);
      });
  }
  
  async takePicture(sourceType) {
    var options = {
      quality: 100,
      sourceType: sourceType,
      targetWidth: 1024,
      targetHeight: 1024,
      destinationType: this.camera.DestinationType.DATA_URL,
      saveToPhotoAlbum: false,
      correctOrientation: true
    };

    this.camera.getPicture(options).then(
      dataUrl => {
        // console.log("takePicture",dataUrl);
        this.getPicture(dataUrl)
          .then(picture => {
            // console.log("picture", picture);
            this.edited = true;
          })
          .catch(err => {
            console.error("error loading takeDemoPicture", err);
          });
      },
      err => {
        this.presentToast("Error while selecting image.");
      }
    );
  }

  onFileInputChange(files: FileList) {
    this.fileToUpload = files.item(0);

    if (this.fileInput.nativeElement.value != "") {
      // console.log('onFileInputChange', this.fileInput.nativeElement.value);
      // console.log('this.fileToUpload', this.fileToUpload);
      this.fileToBase64(this.fileToUpload);
      // this.upload();
    }
  }
  fileToBase64(file) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // console.log(reader.result);
      let data = reader.result.toString();
      data = data.replace("data:image/png;base64,", "");
      data = data.replace("data:image/jpeg;base64,", "");
      data = data.replace("data:image/jpg;base64,", "");
      data = data.replace("data:image/webp;base64,", "");
      data = data.replace("data:image/gif;base64,", "");
      // console.log("file",file);
      // console.log("reader",reader);
      this.edited = true;
      this.getPicture(data);
    };
    reader.onerror = error => {
      console.log("Error: ", error);
    };
  }

  async getPicture(dataUrl) {
    let picture_name = new Date().getTime();
    let picture = {
      title: picture_name,
      contenu: "data:image/png;base64," + dataUrl
    };
    // console.log("getPicture",picture);
    this.user_data.image = picture.contenu;
  }

  presentLoading(content = "Please wait...") {
    this.loading = this.loadingCtrl.create({
      content: content
    });

    this.loading.present();
  }
  async ionViewDidLeave(){
    this.user_data = await this.userProvider.getUser();
  }
  hideLoading() {
    this.loading.dismiss();
  }

  getImageDimensions(base64) {
    return new Promise((resolved, rejected) => {
      var i = new Image();
      i.onload = function() {
        resolved({ w: i.width, h: i.height });
      };
      i.src = "data:image/png;base64," + base64;
    });
  }

  presentToast(message, duration = 3000) {
    // console.log('presentToast', message)
    let toast = this.toastCtrl.create({
      message: message,
      duration: duration,
      position: "middle",
      cssClass: "custom_toast"
    });

    toast.onDidDismiss(() => {
      console.log("Dismissed toast");
    });

    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/account-update/account-update.ts